import * as React from 'react';
import {
    Shimmer,
    ShimmerElementsGroup,
    ShimmerElementType as ElemType,
} from '@fluentui/react/lib/Shimmer';

const ShimmerEntry = () => (
    <div style={{ width: 250, padding: '9px 0 10px 0' }} data-is-focusable={true}>
        <Shimmer
            customElementsGroup={
                <div style={{ display: 'flex' }}>
                    <ShimmerElementsGroup
                        shimmerElements={[
                            { type: ElemType.gap, width: 9, height: 40 },
                            { type: ElemType.circle, height: 32 },
                            { type: ElemType.gap, width: 9, height: 40 },
                        ]}
                    />
                    <ShimmerElementsGroup
                        flexWrap={true}
                        shimmerElements={[
                            { type: ElemType.gap, width: 200, height: 1 },
                            { type: ElemType.line, width: 125, height: 8 },
                            { type: ElemType.gap, width: 75, height: 8 },
                            { type: ElemType.gap, width: 200, height: 4 },
                            { type: ElemType.line, width: 175, height: 8 },
                            { type: ElemType.gap, width: 25, height: 8 },
                            { type: ElemType.gap, width: 200, height: 2 },
                        ]}
                    />
                </div>
            }
        />
    </div>
);

export default ShimmerEntry;
